import React from "react";
import { Link } from "react-router-dom";
import { useContactDialog } from "../context/ContactDialogContext";

const Footer = () => {
  const { openDialog } = useContactDialog();

  return (
    <footer
      className="bg-[#070B1A] border-t border-white/5"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[#d4af37]/40 text-[#d4af37] font-serif text-xl">
              O
            </span>
            <span className="font-serif text-2xl text-white">
              Orkester<span className="gold-text">admin</span>
            </span>
          </div>
          <p className="mt-6 max-w-md text-white/65 leading-relaxed">
            En webbaserad tjänst som hjälper dig att administrera din orkester –
            från konsertplanering till kontrakt, resurser och dokumentation. Allt
            på ett ställe.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Sajt</h4>
          <ul className="space-y-3 text-white/65 text-sm">
            <li>
              <Link to="/" data-testid="footer-home-link" className="hover:text-[#d4af37]">
                Hem
              </Link>
            </li>
            <li>
              <Link to="/funktioner" data-testid="footer-features-link" className="hover:text-[#d4af37]">
                Funktioner
              </Link>
            </li>
            <li>
              <Link to="/priser" data-testid="footer-pricing-link" className="hover:text-[#d4af37]">
                Priser
              </Link>
            </li>
            <li>
              <button
                type="button"
                onClick={() => openDialog(null)}
                data-testid="footer-contact-button"
                className="hover:text-[#d4af37] bg-transparent text-left"
              >
                Kontakt
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Kontakt</h4>
          <button
            type="button"
            onClick={() => openDialog(null)}
            data-testid="footer-contact-cta-button"
            className="btn-ghost-gold inline-flex items-center px-5 py-2.5 rounded-full text-sm"
          >
            Skicka meddelande
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-6 flex justify-end" data-testid="footer-legal-links">
        <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-white/60">
          <li>
            <Link
              to="/villkor"
              data-testid="footer-legal-terms"
              className="hover:text-[#d4af37] transition-colors"
            >
              Villkor
            </Link>
          </li>
          <li>
            <Link
              to="/integritet"
              data-testid="footer-legal-privacy"
              className="hover:text-[#d4af37] transition-colors"
            >
              Integritetspolicy
            </Link>
          </li>
          <li>
            <Link
              to="/cookies"
              data-testid="footer-legal-cookies"
              className="hover:text-[#d4af37] transition-colors"
            >
              Cookies
            </Link>
          </li>
        </ul>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-white/40 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Redoc AB. Alla rättigheter förbehållna.</span>
          <span className="text-white/70" data-testid="footer-credit">
            Web by{" "}
            <a
              href="https://logartgroup.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-link"
              className="text-white hover:text-[#d4af37] transition-colors"
            >
              Logardt Group
            </a>
          </span>
          <span>orkesteradmin.se</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
